/** Campo de interfaz para manual (plantilla Descripción de la interfaz). */
export function grillaCampo(name, controlType, description, behavior, opts = {}) {
  return {
    name,
    controlType,
    required: opts.required ?? false,
    editable: opts.editable ?? true,
    automatic: opts.automatic ?? false,
    description,
    behavior,
    example: opts.example,
  };
}

export const GRILLA_DETALLE_PREREQ = [
  'Sesión con permiso de escritura en el módulo correspondiente.',
  'Productos (y servicios si aplica) dados de alta en Gestión.',
];

export const GRILLA_DETALLE_PROCEDURE = [
  'Abra la pantalla indicada en «Ubicación en el sistema».',
  'Localice el bloque de productos/ítems.',
  'Complete cada control de la fila en el orden que aparece en pantalla (de izquierda a derecha en monitor ancho).',
  'Pulse Agregar en captura rápida o agregue otra fila; elimine con el icono de papelera o ✕.',
  'Guarde el documento cuando todas las filas obligatorias estén completas.',
];
